export default "__VITE_ASSET__787af866__"